/**
 * Fully strips any HTML tags from a string.
 */
export const sanitizeHtml = (str) => {
  if (!str) return '';
  return str.replace(/<[^>]*>?/gm, '');
};

/**
 * Formats a Firestore Timestamp into a readable string: "12 Mar 2026, 5:30 PM"
 */
export const formatTimestamp = (timestamp) => {
  if (!timestamp) return '';
  
  let date;
  if (timestamp.toDate) {
    date = timestamp.toDate();
  } else if (timestamp instanceof Date) {
    date = timestamp;
  } else {
    // If it's a number/string
    date = new Date(timestamp);
  }

  return date.toLocaleString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });
};

/**
 * Reusable event tracking layer (stubbed for future Google Analytics insertion)
 */
export const trackEvent = (eventName, payload = {}) => {
  console.log(`[EVENT TRACKING] ${eventName}`, payload);
  // Future: window.gtag('event', eventName, payload);
};
